// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {
  colors,
  shadows,
  card,
  btn,
  form,
  page,
}                     from '../../../../style/common/partnerStyle';

// ─── Local layout styles only (no logic) ──────────────────────────────────────

const S = {
  page: {
    ...page.padded,
    maxWidth: 620,
    margin: '0 auto',
  },
  footer: {
    display: 'flex',
    gap: 10,
    justifyContent: 'flex-end',
    paddingTop: 20,
    marginTop: 8,
    borderTop: `1px solid ${colors.border}`,
  },
};

class EditMatch extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      match: {
        "name": "",
        "venue": "",
        "game_type": 13,
        "start_time": "19:30:00",
        "end_time": "20:15:00",
        "match_date": moment(),
        },
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_type: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.match);
    new_selected_one['match_date'] = date
    this.setState({match: new_selected_one});
  }

  componentDidMount() {
    this.getMatchList();
  }

  getMatchList() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_match/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_type: data.game_type, match: data.match }))
       .catch(error => error);
  }

  postEditedMatch(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_match/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'match': data});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  dayOfWeek() {
    return [
      {id:0, name: 'Monday'},
      {id:1, name: 'Tuesday'},
      {id:2, name: 'Wednesday'},
      {id:3, name: 'Thursday'},
      {id:4, name: 'Friday'},
      {id:5, name: 'Saturday'},
      {id:6, name: 'Sunday'},
    ]
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.match);
    new_selected_one[name] = event.target.value
    this.setState({match: new_selected_one});
  }

  handleBack(){
    this.props.history.goBack();
    console.log("goBack")
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postEditedMatch(this.state.match, this.props);
  }

  render() {
    return(
      <div style={S.page}>
        <div style={card.wrap}>

          <div style={card.header}>
            <h3 style={card.title}>Edit Match</h3>
          </div>

          <div style={card.body}>
            <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

              <div style={form.row}>
                <label style={form.label}>Batch Name</label>
                <input
                  type="text"
                  style={form.input}
                  name="name"
                  value={this.state.match.name}
                  onChange={this.handleChange}
                />
              </div>

              <div style={form.row}>
                <label style={form.label}>Venue</label>
                <select
                  name="venue"
                  style={form.select}
                  value={this.state.match.venue}
                  onChange={this.handleChange}
                >
                  {this.state.venues.map((x, index) => (
                    <option key={x.id} value={x.id}>{x.name}</option>
                  ))}
                </select>
              </div>

              <div style={form.row}>
                <label style={form.label}>Match Date</label>
                <DatePicker
                  selected={moment(this.state.match.match_date)}
                  onChange={this.handleStartDate}
                />
              </div>

              <div style={form.row}>
                <label style={form.label}>Game Type</label>
                <select
                  name="game_type"
                  style={form.select}
                  value={this.state.match.game_type}
                  onChange={this.handleChange}
                >
                  {this.state.game_type.map((x, index) => (
                    <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))}
                </select>
              </div>

              <div style={form.row}>
                <label style={form.label}>Start Time</label>
                <input
                  type="text"
                  style={form.input}
                  className="required"
                  name="start_time"
                  value={this.state.match.start_time}
                  onChange={this.handleChange}
                  placeholder="19:30:00"
                />
              </div>

              <div style={form.row}>
                <label style={form.label}>End Time</label>
                <input
                  type="text"
                  style={form.input}
                  name="end_time"
                  className="required"
                  value={this.state.match.end_time}
                  onChange={this.handleChange}
                  placeholder="20:30:00"
                />
              </div>

              <div style={S.footer}>
                <input
                  className="button1"
                  type="submit"
                  value="Update"
                  style={btn.primary}
                />
                <input
                  className="button1"
                  type="button"
                  value="Cancel"
                  style={btn.cancel}
                  onClick={() => this.handleBack()}
                />
              </div>

            </form>
          </div>

        </div>
      </div>
    );
  }
}

export default EditMatch;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editMatch/index.js